import {LOADING_SET_INVISIBLE, LOADING_SET_VISIBLE} from "redux/constants/Loading";

const initialState = {
    loading: false,
}

const loading = (state = initialState, action) => {
    switch (action.type) {
        case LOADING_SET_VISIBLE:
            return {
                loading: true,
            };
        case LOADING_SET_INVISIBLE:
            return {
                loading: false,
            };
        default:
            return state;
    }
}

export default loading;